"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BroadcastDataService_1 = require("../../components/BroadcastDataService");
var Player_1 = require("../../components/Player");
var ARCHIVE_TITLE = "archief fragment";
if (siteData) {
    siteData.BNRProgramDescription = jQuery('.program-title').text();
}
if (window['fragment'] && siteData) {
    var dif = (fragment.end - fragment.start) / 60000;
    var time = dif === 60 ? "1 uur" : dif + " minuten";
    siteData.BNRProgramName = ARCHIVE_TITLE;
    siteData.BNRProgramDescription = [fragment.start, time].join(" - ");
}
var player = new Player_1.Player('#player');
if (player.getPlayerType() != 'archief') {
    BroadcastDataService_1.broadcastDataService.listen('broadcastDataService.update', function (event, data) {
        jQuery('.program-title').text(data.title);
        jQuery('.program-description').text(data.leadtext);
        jQuery('.share-social')
            .attr('data-title', data.shareTitle)
            .attr('data-intro', data.shareText);
        if (siteData) {
            siteData.BNRProgramPresenters = data.columnist;
            siteData.BNRProgramName = data.title;
            siteData.BNRProgramDescription = data.leadtext;
        }
    });
}
